import { render } from "./LeeButton.vue?vue&type=template&id=7afe3a2d"
import script from "./LeeButton.vue?vue&type=script&lang=js"
export * from "./LeeButton.vue?vue&type=script&lang=js"

import "./LeeButton.vue?vue&type=style&index=0&id=7afe3a2d&lang=css"

import exportComponent from "F:\\leeao\\leeplus_docs_code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__